<template>
  <div class="tla-form-group" id="tla-registration-group">
    <label v-if="showLabel" for="regNumberDisabled" class="tla-form-group__label tla-form-group__label--required" v-html="labelText"></label>

    <div class="tla-registration">
      <i class="tla-registration__icon">
        <img src="@/assets/images/widgets/euro-badge.svg"/>
      </i>
      <span
        @click="inputClicked()"
        class="tla-registration__wrapper"
        :class="{
          'tla-registration__wrapper--interactive': isInteractive && !showDisabledState,
          'tla-registration__wrapper--disabled': showDisabledState}">
      </span>
      <input
        class="tla-registration__input"
        :class="{
          'tla-registration__input--tick': showTick,
          'tla-form-group__input--error': showError}"
        type="text"
        id="regNumberDisabled"
        name="registrationDisabled"
        v-model="registration"
        placeholder="EJ03 OZF" />
    </div>
    <span v-if="showError" class="tla-form-group__message tla-form-group__message--spaced tla-form-group__message--error">{{ errorMessage }}</span>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Prop, Ref, Inject
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import Valuation from '@/models/valuation/Valuation';

@Component
export default class DisabledRegistrationInputComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: false })
  public showLabel!: boolean;

  @Prop({ default: false })
  public showErrorState!: boolean;

  @Prop({ default: false })
  public showInputTick!: boolean;

  @Prop({ default: false })
  public showDisabledState!: boolean;

  @Prop({ default: false })
  public forceShowInputTick!: boolean;

  @Prop({ default: false })
  public isInteractive!: boolean;

  @Prop({ default: 'Enter your car registration <span>*</span>' })
  public labelText!: string;

  @Prop({ default: 'Please enter your existing vehicle' })
  public errorMessage!: string;

  private regLookupClicked: boolean = false;

  public inputClicked() {
    this.regLookupClicked = true;
    this.$emit('registrationInputClick', true);
  }

  public get valuationRequest() {
    return this.$store.getters['vehicleValuationModule/valuationRequest'];
  }

  public get registration(): string {
    const vehicleValuation: Valuation = this.$store.getters['vehicleValuationModule/vehicleValuation'];
    return vehicleValuation.registration;
  }

  public get showTick(): boolean {
    return (!this.showError && this.showInputTick) || this.forceShowInputTick;
  }

  public get showError(): boolean {
    const dataSet = this.$store.getters['vehicleValuationModule/isRegistrationLookupDataSet'];
    return (this.showErrorState && !dataSet && this.regLookupClicked) || (!dataSet && validationService.hasNextBeenClicked('step3Validator'));
  }
}
</script>
